import React, { Component, createRef } from "react";
import { POST, loading, tokens, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      password_view: "password",
    };
  }
  componentDidMount() {
    loading(false);
    // this.Register(); 
  }
  Login = async () => {
    const { username, password } = this.state;
    await fetch(
      process.env.REACT_APP_API_URL + `/user/${username.split("@")[0]}.json`,
      { method: "GET", headers: { "Content-Type": "application/json" } }
    )
      .then((response) => response.json())
      .then((result) => {
        let data = JSON.parse(atob(result.data));
        console.log(data);
        if (btoa(password) !== data.password) {
          alert("", "warning", "แจ้งเตือน", "รหัสผ่านไม่ตรงกัน");
          return;
        }
        localStorage.setItem("scp-profile", btoa(JSON.stringify({
          fn: data.fullname,
          ep: new Date(
            new Date().setDate(new Date().getDate() + 2)
          ).getTime(),
          ut: data.user_type,
        })));
        window.location.href = "/admin/contact";
      })
      .catch((error) => {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง"
        );
      });

    return;
  };
  Register = async () => {
    await fetch(process.env.REACT_APP_API_URL + `/user/${"sale"}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data:
          btoa(JSON.stringify({
          fullname: "Sale",
          username: "sale",
          password: btoa("qmfoht59id"),
          user_type: "sale",
        })) 
      }),
      }
    );
    alert(
      "login",
      "success",
      "สำเร็จ",
      `การสมัครสมาชิกของท่านเสร็จสมบูรณ์แล้ว`
    );
  };


  render() {
    const { username, password, password_view } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />
        <div className="row w-100 mx-0">
          <div className="col-12 d-flex align-items-center justify-content-center d-md-none bg-secondary-light py-3">
            <img
              alt="logo"
              src={LOGO}
              className="w-75"
              style={{ minWidth: 350 }}
              loading="lazy"
            />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-7 col-xl-6 mx-auto my-5">
              <h2 className="fw-bold text-dark mb-3">เข้าสู่ระบบ</h2>
              <label className="mb-1">ชื่อผู้ใช้</label>
              <input
                className="form-control mb-3"
                type="text"
                placeholder="ชื่อผู้ใช้"
                onChange={(e) => {
                  this.setState({ username: e.target.value });
                }}
                value={username}
              />
              <label className="mb-1">รหัสผ่าน</label>
              <div className="position-relative">
                <input
                  className="form-control mb-3"
                  type={password_view}
                  placeholder="รหัสผ่าน"
                  onChange={(e) => {
                    this.setState({ password: e.target.value });
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Login();
                    }
                  }}
                  value={password}
                />
                <div
                  className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute"
                  style={{ right: 0, top: 1 }}
                  onClick={() => {
                    this.setState({
                      password_view:
                        password_view === "password" ? "text" : "password",
                    });
                  }}
                >
                  {password_view === "password" ? "\uf06e" : "\uf070"}
                </div>
              </div>
              <button
                type="button"
                className="btn btn-dark w-100 mb-3"
                onClick={() => {
                  this.Login();
                }}
              >
                เข้าสู่ระบบ
              </button>
            </div>
          </div>
          <div className="col-6 d-none d-md-flex align-items-center justify-content-center bg-secondary-light min-vh-100">
            <img
              alt="logo"
              src={LOGO}
              style={{ width: "60%", minWidth: 400 }}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    );
  }
}
